/** @file A skin's entries with names resolved, in slot draw order then placeholder (R12-01). */
import type { Doc, Id } from '@pose2d/format/types';

/** One (slot, placeholder) → attachment mapping of a skin. */
export interface SkinEntryRow {
  slot: Id;
  slotName: string;
  placeholder: string;
  attachment: Id;
  attachmentName: string;
}

/** Rows of `skin` (none for an unknown skin): slots in setup draw order (back first), then placeholders by name. */
export function skinEntryRows(doc: Doc, skin: Id): SkinEntryRow[] {
  const rank = new Map(doc.drawOrder.map((id, i): [Id, number] => [id, i]));
  const rows = (doc.skins[skin]?.entries ?? []).map((e) => ({
    slot: e.slot, slotName: doc.slots[e.slot]?.name ?? e.slot, placeholder: e.placeholder,
    attachment: e.attachment, attachmentName: doc.attachments[e.attachment]?.name ?? e.attachment,
  }));
  return rows.sort((a, b) => (rank.get(a.slot) ?? 0) - (rank.get(b.slot) ?? 0) || (a.placeholder < b.placeholder ? -1 : 1));
}
